export interface Job {
  id: number;
  hospitalType: string;
  monthlySalary: string;
  annualSalary: string;
  workStyle: string;
  overtime?: string;
  department: string;
  employmentType?: string;
  qualification?: string;
  allowance: string;
  bonus: string;
  benefits?: string;
  holidays: string;
  location: string;
}

export const jobs: Job[] = [
  {
    id: 1,
    hospitalType: '訪問看護付き有料老人ホーム',
    monthlySalary: '約40〜43.6万円',
    annualSalary: '約553〜610万円',
    workStyle: '2交代(訪問看護・施設看護混合)',
    overtime: '平均月10時間未満',
    department: '訪問看護 / 施設看護（緩和ケア系）',
    allowance: '夜勤手当・資格手当・精勤手当・通勤手当 等',
    bonus: '年2回（支給あり）',
    benefits: '社会保険・健康保険・厚生年金・雇用保険・労災・託児所・寮・退職金制度 等',
    holidays: '年間休日115日・週休2日制・夏季・年末年始休暇 等',
    location: '東京都',
  },
  {
    id: 2,
    hospitalType: '総合病院',
    monthlySalary: '31.3万円〜',
    annualSalary: '約478万円〜',
    workStyle: '2交代',
    overtime: '月8〜17時間程度',
    department: '一般急性期（消化器内科・循環器内科・整形外科 他多数）',
    allowance: '夜勤手当・通勤手当',
    bonus: '年2回',
    benefits: '寮・託児所・医療費免除・教育支援',
    holidays: '年間休日122日 / 4週8休以上',
    location: '埼玉県',
  },
  {
    id: 3,
    hospitalType: '有料老人ホーム / 訪問看護',
    monthlySalary: '40.0〜43.6万円',
    annualSalary: '約553〜599万円',
    workStyle: '2交代（訪問看護含む） or 日勤のみ案件あり',
    overtime: '月10時間程度',
    department: '訪問看護 / 介護・福祉系',
    allowance: '夜勤手当・資格手当・精勤手当',
    bonus: '年2回（3.5ヶ月 相当）',
    benefits: '社会保険・託児所・寮・退職金制度・車通勤可',
    holidays: '年間休日115日 / 週休2日制 / 夏季・年末年始休暇',
    location: '東京都',
  },
  {
    id: 4,
    hospitalType: 'ケアミックス病院',
    monthlySalary: '36.3万円',
    annualSalary: '約498万円',
    workStyle: '2交代',
    overtime: 'あり（部署により変動）',
    department: '内科・外科・整形外科・循環器科・小児科 他多数',
    allowance: '夜勤手当・各種手当',
    bonus: '約3ヶ月分',
    benefits: '寮・託児所・車通勤可・退職金制度',
    holidays: '年間休日115日 / 4週8休以上',
    location: '神奈川県',
  },
  {
    id: 5,
    hospitalType: '一般病院',
    monthlySalary: '34.2万円',
    annualSalary: '462万円',
    workStyle: '2交代（常勤）',
    department:
      '外科・整形外科・脳神経外科・内科・循環器科・消化器科・リハビリテーション科・放射線科・形成外科・呼吸器科・泌尿器科・麻酔科・歯科・リウマチ科・皮膚科・心臓血管外科・呼吸器外科',
    employmentType: '常勤（正看護師）',
    allowance: '夜勤手当（18,000円/回）・休日手当・通勤手当 全額支給等',
    bonus: '年2回（例：57〜68万円）',
    benefits: '社会保険完備・寮・託児所・退職金制度・車通勤可・保育サポート 等',
    holidays: '年間休日120日／4週8休制・夏季休暇・年末年始休暇・有給休暇・育児休業 等',
    location: '埼玉県',
  },
  {
    id: 6,
    hospitalType: '有床クリニック（病棟）',
    monthlySalary: '37.6万円',
    annualSalary: '約500万円',
    workStyle: '2交代',
    overtime: 'ほぼなし',
    department: '内科中心・高齢者ケア中心',
    employmentType: '常勤',
    qualification: '正看護師',
    allowance: '夜勤手当・資格手当・職務手当',
    bonus: '年2回',
    benefits: '社会保険・育児手当',
    holidays: '年間休日120日 / 4週8休制',
    location: '神奈川県',
  },
  {
    id: 7,
    hospitalType: 'ケアミックス病院',
    monthlySalary: '約36.5万円',
    annualSalary: '約530万円',
    workStyle: '2交代（一般病棟・療養病棟）',
    department: '内科系＋リハビリ科・専門内科多科目',
    allowance: '夜勤手当含む想定',
    bonus: '約92.2万円（一例）',
    holidays: '4週8休以上',
    location: '東京都',
  },
  {
    id: 8,
    hospitalType: 'ケアミックス病院',
    monthlySalary: '約34.9万円',
    annualSalary: '約525万円',
    workStyle: '2交代（常勤）',
    overtime: '記載なし',
    department: '病棟（療養含む）',
    allowance: '夜勤手当含む想定',
    bonus: '年4ヶ月分（目安）',
    benefits: '社保等',
    holidays: '年間125日 / 4週8休以上',
    location: '神奈川県',
  },
];
